import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiError, BaseVisualizacao, BaseVisualizacaoService, DataTablesService, MessageService } from '../../core';
import { MotivoPerdaVendaCrudHttpService } from './services';

import { MotivoPerdaVenda } from './motivo-perda-venda';

@Component({
    selector: 'sgt-motivo-perda-venda',
    templateUrl: './motivo-perda-venda.component.html',
    styleUrls: ['./motivo-perda-venda.component.less']
})
export class MotivoPerdaVendaComponent implements BaseVisualizacao<MotivoPerdaVenda>, OnInit {
    entities: MotivoPerdaVenda[];
    dataTable: any;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private MotivoPerdaVendaCrudHttpService: MotivoPerdaVendaCrudHttpService) { }


    ngOnInit() {
        this.search();
    }

    search() {
        this.MotivoPerdaVendaCrudHttpService.search()
            .subscribe(
                entities => {
                    this.entities = entities;
                    this.showTable();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os motivos', error)
            );
    }

    showTable() {
        this.dataTablesService.showTable('#tableMotivosPerdasVendas', this.dataTable)
            .then(dataTable => {
                this.dataTable = dataTable;
                this.baseVisualizacaoService.ativarArmazenamento(this.dataTable, null);
            });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: MotivoPerdaVenda) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: MotivoPerdaVenda) {
        this.messageService.confirm(`Deseja realmente excluir o motivo: ${entity.nome}?`).then(result => {
            if (result) {
                this.MotivoPerdaVendaCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir o motivo: ${entity.nome}`, error)
                    );
            }
        });
    }
}
